<div class="blurred-section {{ blur }}" [style.background-image]="'url(' + image?.filename + ')'">
  <ndc-dynamic
    *ngFor="let blok of body; trackBy: trackByFunction"
    [ndcDynamicComponent]="components[blok.component]"
    [ndcDynamicInputs]="$any(blok)"
  ></ndc-dynamic>
</div>
